import { env } from './environment'

export const VivaAccount = {
    email :   env == 'prod' ? 'gijodim352@slvlog.com' : 'pegosa9880@slvlog.com',
    password :  env == 'test' ? 'Aerobus001' : 'Aerobus001'
}